import { Plugin } from '@ckeditor/ckeditor5-core';
import { FileRepository } from '@ckeditor/ckeditor5-upload/src/filerepository';

export default class RocUploadAdapter extends Plugin {
    /**
     * @inheritDoc
     */
    static get requires() {
        return [FileRepository];
    }
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'RocUploadAdapter';
    }
    /**
     * @inheritDoc
     */
    init() {
        const uploadasseteditor = this.editor.config.get('uploadasset');
        this.editor.plugins.get(FileRepository).createUploadAdapter = loader => {
            return new Adapter(loader, uploadasseteditor);
        };
    }
}
/**
 * Upload adapter.
 */
class Adapter {
    /**
     * Creates a new adapter instance.
     */
    constructor(loader, uploadasseteditor) {
        this.loader = loader;
        this.uploadasseteditor = uploadasseteditor;
    }
    /**
     * Starts the upload process.
     */
    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                this._sendRequest(file, resolve, reject);
            }));
    }

    /**
     * Sends the file, promise's resolve and reject callbacks.
     */
    _sendRequest(file, resolve, reject) {
        const rocAssetConfig = this.uploadasseteditor;
        if (rocAssetConfig['uploadAction']) {
            rocAssetConfig.uploadAction(file, resolve, reject);
        }
    }
}